import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, watch } from "vue";
import * as THREE from "three";
import { cfgHelpers } from "./ctxConfig";

// Props

import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "CtxHelpers",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  showHelpers: Boolean,
  gridHelperSize: {
    type: Number,
    default: 1, // 1, default value for gridHelperSize : 100 mm
  },
  gridHelperDivision: {
    type: Number,
    default: 1, // 1, default value for gridHelperDivision
  },
  //scene: Object, //Object, // Use Object type for the scene prop
  scene: {
    type: Object as () => THREE.Scene,
    default: () => new THREE.Scene(), // Default value for the scene prop
  },
},
  setup(__props) {

const props = __props;



const helperContainer = ref<HTMLElement | null>(null);
const helperGroup = new THREE.Group();

// Axis helper
// An axis object to visualize the 3 axes in a simple way.
// The X axis is red. The Y axis is green. The Z axis is blue.
// https://threejs.org/docs/index.html?q=axes#api/en/helpers/AxesHelper
// size: default 10 (길이)
const axisHelper = new THREE.AxesHelper(cfgHelpers.axis.size); // 10

// Grid helper
// https://threejs.org/docs/#api/en/helpers/GHelper
// const gridHelper = new THREE.GridHelper( size, divisions );
// size: default 10
// divisions : The number of divisions across the grid. Default is 10
// colorCenterLine -- The color of the centerline. This can be a Color, a hexadecimal value and an CSS-Color name. Default is 0x444444
// colorGrid -- The color of the lines of the grid. This can be a Color, a hexadecimal value and an CSS-Color name. Default is 0x888888
// #AARRGGBB (AA is alpha in hex) : 실제로 ALPHA는 적용되지 않음

const gridHelper = new THREE.GridHelper(
  cfgHelpers.grid.size, // 10
  cfgHelpers.grid.division, // 10
  cfgHelpers.grid.colorCenterLine, // 0x444444 (default)
  cfgHelpers.grid.colorGrid // 0x888888 (default)
);

// Set up the helpers
onMounted(() => {
  if (!helperContainer.value || !props.scene) {
    return;
  }

  // Adjust grid helper scale,division, rotation
  gridHelper.scale.set(props.gridHelperSize, props.gridHelperSize, props.gridHelperSize);
  gridHelper.geometry.scale(props.gridHelperDivision, props.gridHelperDivision, props.gridHelperDivision);
  gridHelper.rotation.x = -Math.PI / 2; // X+ pointing to the right

  gridHelper.name = "gridHelper";
  helperGroup.add(gridHelper);
  helperGroup.name = "helperGroup";

  // Add the helper group to the scene if it exists
  if (props.scene) {
    props.scene.add(helperGroup);
  }

  // Watch the scene prop for changes and add/remove the helperGroup accordingly
  watch(
    () => props.scene,
    (newScene, oldScene) => {
      if (newScene && !oldScene) {
        newScene.add(helperGroup);
      } else if (!newScene && oldScene) {
        oldScene.remove(helperGroup);
      }
    }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref_key: "helperContainer",
      ref: helperContainer,
      class: "helper-container"
    }, null, 512)
  ]))
}
}

})